import type { ReactNode } from "react"

import MemberLayoutTemplate from "@/layouts/member/member-sidebar-layout"
import type { BreadcrumbItem } from "@/types"

interface MemberLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

export default function MemberLayout({
  children,
  breadcrumbs,
  ...props
}: MemberLayoutProps) {
  return (
    <MemberLayoutTemplate breadcrumbs={breadcrumbs} {...props}>
      {children}
    </MemberLayoutTemplate>
  )
}
